<template>

    <div class="content_journal single_view" v-show="proofLoginStatus">

        <!-- <h1 class="entry-title ueberschrift">Empfangsjournal</h1> -->

    <div style="overflow:hidden;margin-bottom:40px;margin-top:35px;">
        <div class="closeButtonAndBack fixlineheight" @click="backToOverview" v-if="referer == 'journal'"><i class="fa-solid fa-xmark"></i></div>
        <div class="closeButtonAndBack fixlineheight" @click="backToSearchOverview" v-else-if="referer == 'suche'"><i class="fa-solid fa-xmark"></i></div>
        <div class="closeButtonAndBack fixlineheight" v-else><i class="fa-solid fa-xmark"></i></div>

        <div style="float:left;">
            <div style="font-size:27px;">
                <strong>{{loadedPDFMetaData['filename']}}</strong>
<!--                 <span v-for="(value, name) of loadedPDFMetaData['filename']">
                    {{value | trim}}
                </span> -->

            </div>
            erstellt am {{ loadedPDFMetaData['filedate'] | formatDateTime}}
        </div>

    </div>

    <div style="clear:both;">

        <div style="width:65%;float:left;">
            <!-- <PDFViewer :source="loadedPDF" :controls="controls" style="height:800px" :settings="settings" ref="mapRef" :zoom="150" /> -->
            <!-- <div v-if="!pdfRendered">Loading the PDF...</div>
            <pdf-viewer :pdf-data="loadedPDF" @rendered="pdfRendered=true" v-if="loadedPDF"></pdf-viewer> -->
            <div v-if="loadedPDFMetaData['cm:mimetype'] == 'application/pdf'">
                <iframe :src="loadedPDF" width="100%" height="1000px" style="border:none;" /></iframe>
            </div>
            <div v-else>
                <div width="100%" style="background-color:#f4f4f4;padding:20px;border-radius:8px;font-weight:bold;">
                    <iframe :src="loadedPDF" width="100%" height="1000px" style="border:none;" /></iframe>
                </div>
            </div>
        </div>

        <div style="float:left;width:35%;margin-bottom:40px;" v-if="loadedPDFMetaData['statuslist']">
            <div v-if="loadedPDFMetaData['statuslist'][0] == 'Rechnung_valid-e-invoice_true'" class="headBlock" style="margin-left:50px;padding:20px;background-color: #7cb430; font-weight:bold;padding-top:15px;padding-bottom:15px;color:#fff;font-size:15px;border-radius:8px;">
                <i class="fa-solid fa-circle-check" style="font-size:20px;padding-right:5px;"></i> {{$status[loadedPDFMetaData['statuslist'][0]]}}
            </div> 
            <div v-else-if="loadedPDFMetaData['statuslist'][0] == 'Rechnung_no-e-invoice_true'" class="headBlock" style="margin-left:50px;padding:20px;background-color: #5f5e5e; font-weight:bold;padding-top:15px;padding-bottom:15px;color:#fff;font-size:15px;border-radius:8px;">
                <i class="fa-solid fa-circle-exclamation" style="font-size:20px;padding-right:5px;"></i> {{$status[loadedPDFMetaData['statuslist'][0]]}}
            </div> 
            <div v-else-if="loadedPDFMetaData['statuslist'][0] == 'Rechnung_validation-failed_true'" class="headBlock" style="margin-left:50px;padding:20px;background-color: #5f5e5e; font-weight:bold;padding-top:15px;padding-bottom:15px;color:#fff;font-size:15px;border-radius:8px;">
                <i class="fa-solid fa-solid fa-circle-info" style="font-size:20px;padding-right:5px;"></i> {{$status[loadedPDFMetaData['statuslist'][0]]}}
            </div> 
            <div v-else class="headBlock" style="margin-left:50px;padding:20px;background-color: #af301c;font-weight:bold;padding-top:15px;padding-bottom:15px;color:#fff;font-size:15px;border-radius:8px;">
                <i class="fa-solid fa-circle-xmark" style="font-size:20px;padding-right:5px;"></i> {{$status[loadedPDFMetaData['statuslist'][0]]}}
            </div>      
        </div>

        <div style="float:left;width:35%;margin-bottom:40px;" v-if="getDocumentRelations.length > 0">
            <div class="headBlock" style="margin-left:50px;padding:20px;background-color: #5f5e5e;font-weight:bold;padding-top:15px;padding-bottom:15px;color:#fff;font-size:15px;border-top-left-radius: 8px;border-top-right-radius: 8px;">
                Dokumente
            </div>
            <div style="margin-left:50px;background-color:#f4f4f4;padding:15px;border-bottom-left-radius:8px;border-bottom-right-radius:8px;">
                <table v-if="loadedPDFMetaData" class="metaDataTable" width="100%;">
                    <tr v-if="loadedPDFMetaData['filename'] && toggleHauptDokument">
                        <td colspan="2">
                            <a @click="showDocumentInFrame(hauptDokument, 'main', 'main')" style="cursor:pointer;">
                                <span v-if="loadedPDFMetaData['cm:mimetype'] == 'application/pdf'">
                                    <i class="fa-solid fa-file-pdf" style="padding-right:5px;"></i> ausgewähltes Dokument
                                </span>
                                <span v-else>
                                    <i class="fa-solid fa-code" style="padding-right:5px;"></i> ausgewähltes Dokument
                                </span>
                            </a>
                        </td>
                    </tr>
                    <tr v-if="toggleHauptDokument"><td style="padding:0px;"><hr/></td></tr>
                    <tr v-for="(item, $index) of getDocumentRelations" :class="[currentDocumentTitle == item['title'] ? 'activeClass' : 'noActiveClass']">
                        <td>
                            <!-- <a :href="item['url']" target="_blank">{{item['title']}}</a> -->
                            <a @click="showDocumentInFrame(item['url'], item['title'], 'child')" style="cursor:pointer;">
                                <span v-if="item['title'] == 'INVOICE_VISUALIZATION'">
                                    <i class="fa-solid fa-file-pdf" style="padding-right:5px;"></i> Sichtkopie
                                </span>
                                <span v-else-if="item['title'] == 'VALIDATION_VISUALIZED_REPORT'">
                                    <i class="fa-solid fa-file-pdf" style="padding-right:5px;"></i> Validierungsbericht / PDF
                                </span>
                                <span v-else-if="item['title'] == 'VALIDATION_XML_REPORT'">
                                    <i class="fa-solid fa-code" style="padding-right:5px;"></i> Validierungsbericht / XML
                                </span>
                                <span v-else-if="item['title'] == 'INVOICE_XML_ATTACHMENT'">
                                   <i class="fa-solid fa-code" style="padding-right:5px;"></i> XML-Rechnung
                                </span>
                                <span v-else-if="item['title'] == 'SOURCE_DOCUMENT'">
                                    <i class="fa-solid fa-file-invoice" style="padding-right:5px;"></i> Ursprungsdatei
                                </span>
                                <span v-else>
                                    {{item['title']}}
                                </span>
                            </a>
                        </td>
                    </tr>
                </table>
            </div> 
        </div>

        <div style="float:left;width:35%;">
            <div class="headBlock" style="margin-left:50px;padding:20px;background-color: #5f5e5e;font-weight:bold;padding-top:15px;padding-bottom:15px;color:#fff;font-size:15px;border-top-left-radius: 8px;border-top-right-radius: 8px;">
                Metainformationen
            </div>
            <div style="margin-left:50px;background-color:#f4f4f4;padding:15px;border-bottom-left-radius:8px;border-bottom-right-radius:8px;">
                <table v-if="loadedPDFMetaData" class="metaDataTable" width="100%;">

<!--                <tr v-for="(value, name) of loadedPDFMetaData" v-if="name != 'statuslist' && name != 'relation' && name != 'id' && name != 'untermandant' && name != 'identifiertransformationserver'">
                        <td style="word-wrap: break-word;max-width: 380px;">
                            <span v-if="$metaFields[name]">{{$metaFields[name]}}</span>
                            <span v-else>{{name}}</span>
                            <br/>
                            <span v-if="
                                name == 'belegdatum' ||
                                name == 'filedate' ||
                                name == 'rechnungleistungsdatum' ||
                                name == 'rechnungdatum'" style="font-weight:bold">
                                    {{value | formatDateTime}}
                            </span>
                            <span v-else-if="
                                name == 'rechnungzahlbetrag' ||
                                name == 'rechnungnetto1' ||
                                name == 'rechnungbruttogesamt' ||
                                name == 'rechnungmehrwertsteuergesamt' ||
                                name == 'rechnungnettogesamt'" style="font-weight:bold">
                                    {{value | formatCurrency}}
                            </span>
                            <span v-else style="font-weight:bold">{{value}}</span>
                        </td>
                    </tr> -->

                    <tr v-if="loadedPDFMetaData['filename']">
                        <td style="word-wrap: break-word;max-width: 380px;">
                            Dateiname<br/>
                            <span style="font-weight:bold;">{{loadedPDFMetaData['filename']}}</span>
                        </td>
                    </tr>
                    <tr v-if="loadedPDFMetaData['belegtyp']">
                        <td style="word-wrap: break-word;max-width: 380px;">
                            Belegtyp<br/>
                            <span style="font-weight:bold;">{{loadedPDFMetaData['belegtyp']}}</span>
                        </td>
                    </tr>
                    <tr v-if="loadedPDFMetaData['qualifizierter_datentyp']">
                        <td style="word-wrap: break-word;max-width: 380px;">
                            Qualifizierter Datentyp<br/>
                            <span style="font-weight:bold;">{{loadedPDFMetaData['qualifizierter_datentyp']}}</span>
                        </td>
                    </tr>
                    <tr v-if="loadedPDFMetaData['belegnummer']">
                        <td style="word-wrap: break-word;max-width: 380px;">
                            Rechnungsnummer<br/>
                            <span style="font-weight:bold;">{{loadedPDFMetaData['belegnummer']}}</span>
                        </td>
                    </tr>
                    <tr v-if="loadedPDFMetaData['belegdatum']">
                        <td style="word-wrap: break-word;max-width: 380px;">
                            Belegdatum<br/>
                            <span style="font-weight:bold;">{{loadedPDFMetaData['belegdatum'] | formatDate}}</span>
                        </td>
                    </tr>
                    <tr v-if="loadedPDFMetaData['filedate']">
                        <td style="word-wrap: break-word;max-width: 380px;">
                            Eingangsdatum<br/>
                            <span style="font-weight:bold;">{{loadedPDFMetaData['filedate'] | formatDateTime}}</span>
                        </td>
                    </tr>
                    <tr v-if="loadedPDFMetaData['rechnungleistungsdatum']">
                        <td style="word-wrap: break-word;max-width: 380px;">
                            Rechnungsleistungsdatum<br/>
                            <span style="font-weight:bold;">{{loadedPDFMetaData['rechnungleistungsdatum'] | formatDate}}</span>
                        </td>
                    </tr>
                    <tr v-if="loadedPDFMetaData['kreditorname']">
                        <td style="word-wrap: break-word;max-width: 380px;">
                            Rechnungssteller<br/>
                            <span style="font-weight:bold;">{{loadedPDFMetaData['kreditorname']}}</span>
                        </td>
                    </tr>
                    <tr v-if="loadedPDFMetaData['rechnungwaehrunggesamt']">
                        <td style="word-wrap: break-word;max-width: 380px;">
                            Währung<br/>
                            <span style="font-weight:bold;">{{loadedPDFMetaData['rechnungwaehrunggesamt']}}</span>
                        </td>
                    </tr>
                    <tr v-if="loadedPDFMetaData['rechnungnettogesamt']">
                        <td style="word-wrap: break-word;max-width: 380px;">
                            Nettobetrag<br/>
                            <span style="font-weight:bold;">{{loadedPDFMetaData['rechnungnettogesamt'] | formatCurrency}}</span>
                        </td>
                    </tr>
                    <tr v-if="loadedPDFMetaData['rechnungmehrwertsteuergesamt']">
                        <td style="word-wrap: break-word;max-width: 380px;">
                            Mehrwertsteuer Gesamt<br/>
                            <span style="font-weight:bold;">{{loadedPDFMetaData['rechnungmehrwertsteuergesamt'] | formatCurrency}}</span>
                        </td>
                    </tr>
                    <tr v-if="loadedPDFMetaData['rechnungbruttogesamt']">
                        <td style="word-wrap: break-word;max-width: 380px;">
                            Bruttobetrag<br/>
                            <span style="font-weight:bold;">{{loadedPDFMetaData['rechnungbruttogesamt'] | formatCurrency}}</span>
                        </td>
                    </tr>
                    <tr v-if="loadedPDFMetaData['rechnungfaelligkeitsdatum']">
                        <td style="word-wrap: break-word;max-width: 380px;">
                            Fälligkeitsdatum<br/>
                            <span style="font-weight:bold;">{{loadedPDFMetaData['rechnungfaelligkeitsdatum'] | formatDate}}</span>
                        </td>
                    </tr>
                    <tr v-if="loadedPDFMetaData['datenherkunft']">
                        <td style="word-wrap: break-word;max-width: 380px;">
                            Datenherkunft<br/>
                            <span style="font-weight:bold;">{{loadedPDFMetaData['datenherkunft']}}</span>
                        </td>
                    </tr>             

                </table>
            </div> 
        </div>

    </div>

</div><!-- content_dashboard -->

</template>

<script>
//import pdf from 'vue-pdf'
//import pdf from 'pdfvuer'
//import PDFViewer from 'pdf-viewer-vue/dist/vue2-pdf-viewer'
//import PDFComponent from './pdf-viewer.vue'
//import VuePdfApp from "vue-pdf-app";
//import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
//import "vue-pdf-app/dist/icons/main.css";
//import SucheOverview from './SucheOverview'
import datatypes from '../public/qualified_datatypes.json'
export default {

    data() {
        return {
            wpData, // global data made available via wp_localize_script.
            loadedPDF: "",
            hauptDokument: "",
            filename: null,
            zoom: 400,
            referer: "",
            controls: [
                'zoom',
                'catalog',
                'switchPage'
            ],
            settings: {
                defaultZoom: 150,
                zoom: 150
            },
            pdfRendered: false,
            toggleHauptDokument: false,
            currentDocumentTitle: "main",
            datatypes: datatypes
        };
    },

    beforeMount() {
        if (this.$route.params.referer) {
            this.referer = this.$route.params.referer      
        }
        if (this.$route.params.noderef) {

            var data = {
                'nonce': this.wpData.nonce,
                'restURL': this.wpData.rest_url,
                //'ticket': this.$route.params.ticket,
                'noderef': this.$route.params.noderef,
                'mandant': this.$store.getters.getMandant
            }

            this.$store.dispatch('getDocumentInfos', data)
                .then(resp => {
                    //console.log(resp.data.data)
                    var mimetype = resp.data.data['content-type']
                    if (mimetype == "text/xml") {
                        mimetype = "application/xml"
                    }
                    this.loadedPDF = this.wpData.rest_url + '/custom/v1/Document' + '?_wpnonce=' + this.wpData.nonce + '&noderef=' + this.$route.params.noderef + '&mandant=' + this.$store.getters.getMandant + '&mimetype=' + mimetype
                    this.hauptDokument = this.loadedPDF

                    if (typeof resp.data.data['datenherkunft'] !== 'undefined' && resp.data.data['datenherkunft'].length !== 0) {
                        var datenherkunft = resp.data.data['datenherkunft']
                        var datenherkunftArray = datenherkunft.split(";,;")
                        if (datenherkunftArray.length > 4) {
                            var datenherkunftString = "Betreff: " + datenherkunftArray[4] + ", Absender: " + datenherkunftArray[1]
                            resp.data.data['datenherkunft'] = datenherkunftString
                        }
                    }

                    // if (typeof resp.data.data['filename'] !== 'undefined' && resp.data.data['filename'].length !== 0) {
                    //     var dateiname = resp.data.data['filename']
                    //     resp.data.data['filename'] = dateiname.match(/.{1,40}/g)
                    // }

                    this.customizeBelegtypen(resp.data.data)
                    this.$store.commit('setLoadedPDFMetaData', resp.data.data)

                    if (typeof resp.data.data['relation'] !== 'undefined' && resp.data.data['relation'].length !== 0) {
                        var relations = []
                        resp.data.data['relation'].forEach(element => {
                            var relation = element.split(";")
                            var data = {
                                'nonce': this.wpData.nonce,
                                'restURL': this.wpData.rest_url,
                                //'ticket': this.$route.params.ticket,
                                'noderef': relation[1],
                                'mandant': this.$store.getters.getMandant
                            }
                            this.$store.dispatch('getDocumentInfos', data)
                                .then(resp => {
                                    var mimetype = resp.data.data['content-type']
                                    if (mimetype == "text/xml") {
                                        mimetype = "application/xml"
                                    }
                                    var relationURL = this.wpData.rest_url + '/custom/v1/Document' + '?_wpnonce=' + this.wpData.nonce + '&noderef=' + relation[1] + '&mandant=' + this.$store.getters.getMandant + '&mimetype=' + mimetype
                                    relations.push({title: relation[0], url: relationURL})
                                    this.$store.commit('setStopLoadingWorkingScreen')
                                })
                                .catch(err => {
                                    console.log("Fehler beim Laden der Dokumenteninfos der Relations")
                                    this.$store.commit('setStopLoadingWorkingScreen')
                                })

                        });
                        this.$store.commit('setDocumentRelations', relations)

                    } else {
                        this.$store.commit('setStopLoadingWorkingScreen')
                    }

                })
                .catch(err => {
                    console.log("Fehler beim Laden weitere Dokumenteninfos")
                    this.$store.commit('setStopLoadingWorkingScreen')
                })  

        } else {
            this.$router.push('/');
        }
   },

   computed: {
        proofLoginStatus() {
            if (this.$store.getters.isPortinvoiceLoggedIn != "") {
                return true;
            } else {
                this.$router.push('/noAccess');
            }
        },
        loadedPDFMetaData() {
            return this.$store.getters.getLoadedPDFMetaData
        },
        getDocumentRelations() {
            return this.$store.getters.getDocumentRelations
        }
   },

    methods: {

        customizeBelegtypen(doc) {
            if (doc.hasOwnProperty("datentyp_schema") && doc.hasOwnProperty("qualifizierter_datentyp")) {
                var schema = doc['datentyp_schema']
                var datentyp = doc['qualifizierter_datentyp']
                if (this.datatypes[schema].data_types[datentyp].localization.de.name != "") {
                    var customizeName = this.datatypes[schema].data_types[datentyp].localization.de.name
                } else {
                    var customizeName = this.datatypes[schema].data_types[datentyp].localization.en.name
                }
                doc['qualifizierter_datentyp'] = datentyp + " - " + customizeName
            }
        },

          backToOverview() {
            this.$router.push({ path: '/' })
          },

          backToSearchOverview() {
            console.log("back to search")
            this.$router.push({
                name: 'Archivsuche',
                params: {
                    backToSearchOverview: 'true'
                }
            })
          },

          showDocumentInFrame(url, title, typ) {
            if (typ == 'child') {
                this.toggleHauptDokument = true
            } else {
                this.toggleHauptDokument = false
            }
            this.loadedPDF = url
            this.currentDocumentTitle = title
          }

    },
   components: {
      //pdf,
      //PDFViewer,
      //VuePdfApp
      //VuePdfEmbed,
      //'pdf-viewer':PDFComponent
   }
};
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/DocumentSingleView.vue